import { Grid } from "@mui/material";
import DatePicker from "@poseidon/ui/components/form/DatePicker";
import { FullWidthField } from "@poseidon/ui/components/form/FullWidthField";
import { Panel } from "@poseidon/ui/components/Panel";
import { Field } from "formik";

export function BoatSpecificationFields({ asDealer }) {
  return (
    <Panel title="Boat Specifications">
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="yearBuilt"
            label="Year of Manufacture"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="engineType"
            label="Engine Type"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="engineNumber"
            label="Engine Number(s)"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="officialNumber"
            label="Official Number (if applicable)"
            margin="none"
          />
        </Grid>
        {!asDealer && (
          <Grid item xs={12} sm={6}>
            <Field
              component={DatePicker}
              name="insuranceExpiryDate"
              label="Insurance Expiry Date"
              margin="none"
            />
          </Grid>
        )}
      </Grid>
    </Panel>
  );
}
